import React from 'react'
import { Link } from 'react-router-dom'

export default class PageNotFound extends React.Component {
  render () {
    return (
      <div className='error'>
        <h1>Oops! Page Not Found</h1>
        <p>The page you requested has not been found. Click <Link to={'/'}>here</Link> to return home.</p>
      </div>
    )
  }
}
